// extracted by mini-css-extract-plugin
export default {"panel":"panel--nU1Ry"};